import React from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../ui/TextField";

const defaultData = {};

const styles = () => ({
    root: {
        maxWidth: 774,
        minWidth: 400,
        "& .MuiFormLabel-root": {
            whiteSpace: "nowrap"
        },
        "& .MuiInputBase-input.Mui-disabled": {
            color: "#000"
        }
    },
    heading: {
        fontSize: 14,
        display: "flex",
        alignItems: "center",
        color: "#000000",
        margin: "25px 0 15px 0"
    },
    block: {},
    checkbox: {
        "& > .MuiCheckbox-colorPrimary.Mui-checked": {
            color: "rgba(0, 127, 189, 0.7);"
        }
    },
    label: {
        fontSize: 12
    },
    avatarContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        "& > span": {
            marginLeft: 10
        }
    }
});

const BankCredentials = ({ disabled, onFormChange, initialData, classes, editmode }) => {
    const [data, setData] = React.useState(initialData || defaultData);

    const onChange = (field, value) => {
        const newState = {
            ...data,
            [field]: value
        };

        setData(newState);
        onFormChange(newState);
    };

    return (
        <div className={classes.root}>
            <Typography className={classes.heading}>
                Основные сведения
            </Typography>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      //required
                        value={data.account || ""}
                        onChange={e => onChange("account", e.target.value)}
                        label="Расчетный счет"
                        placeholder="XXXXXXXXXXXXXXXXXXXX"
                        disabled={disabled}
                        readOnly={!editmode}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        //required
                        value={data.corrAccount || ""}
                        onChange={e => onChange("corrAccount", e.target.value)}
                        label="Корреспондентский счет"
                        placeholder="XXXXXXXXXXXXXXXXXXXX"
                        disabled={disabled}
                        readOnly={!editmode}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        value={data.bic || ""}
                        onChange={e => onChange("bic", e.target.value)}
                        label="БИК"
                        placeholder="XXXXXXXXX"
                        disabled={disabled}
                        readOnly={!editmode}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={8}>
                    <TextField
                        value={data.bank || ""}
                        onChange={e => onChange("bank", e.target.value)}
                        label="Наименование банка"
                        disabled={disabled}
                        readOnly={!editmode}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        value={data.note || ""}
                        onChange={e => onChange("note", e.target.value)}
                        label="Примечание"
                        placeholder="XXXXXXXXXXXXXXXXXXXX"
                        disabled={disabled}
                        readOnly={!editmode}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default withStyles(styles)(BankCredentials);
